var a = Object.defineProperty, h = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var m = Object.prototype.hasOwnProperty, P = Object.prototype.propertyIsEnumerable;
var t = (l, e, o) => e in l ? a(l, e, { enumerable: !0, configurable: !0, writable: !0, value: o }) : l[e] = o, n = (l, e) => {
  for (var o in e || (e = {}))
    m.call(e, o) && t(l, o, e[o]);
  if (r)
    for (var o of r(e))
      P.call(e, o) && t(l, o, e[o]);
  return l;
}, d = (l, e) => h(l, s(e));
import { jsx as p } from "react/jsx-runtime";
import { components as f } from "react-select";
function b(l) {
  const {
    isMulti: e,
    showSelectedOptionInPlaceholder: o,
    value: c
  } = l.selectProps, i = !e && o && (c != null && c.label) ? c.label : l.children;
  return /* @__PURE__ */ p(f.Placeholder, d(n({}, l), { children: i }));
}
b.displayName = "Placeholder";
export {
  b as Placeholder
};
//# sourceMappingURL=Placeholder.es.js.map
